export default {
	badges: {
		cancelled: 'Cancelled',
		contacted: 'Contacted',
		delivered: 'Delivered',
		fallback: 'No data',
		mark: 'Mark as delivered',
		sold: {
			checks_complete: 'Checks complete',
			sold_confirmed: 'Reviewing documents',
			sold_wait: 'Awaiting confirmation',
		},
		transport_requested: 'Delivery requested',
		unmark: 'Unmark as delivered',
	},
	headers: {
		CTA: '',
		dateBid: 'Date bid',
		dateWon: 'Date won',
		price: 'Price',
		status: 'Status',
		vehicle: 'Vehicle',
	},
	list: {
		contextMenu: 'Vehicle context menu',
	},
	priceBreakdownPopover: {
		maxBid: 'Your max bid',
		maxOffer: 'Your offer',
		mechanicalGuaranteeFee: 'Motorway Protect (incl. VAT if applicable)',
		mechanicalGuaranteeFeeTrial: 'Motorway Protect (Trial period)',
		motorwayFee: 'Motorway fee (incl. VAT)',
		savings: 'Savings',
		title: 'Price breakdown',
		totalToPay: 'Total',
		transportFee: 'Transport fee (incl. VAT)',
		vehiclePrice: 'Vehicle price',
	},
};
